var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEllipsis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "3px",
    viewBox: "0 0 13 3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3711B979-E16C-482E-9322-87FE0FB5DA89_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arveldus---Tehingud---Grouped",
    transform: "translate(-812.000000, -2222.000000)",
    fill: "#909090"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Paginator",
    transform: "translate(486.000000, 2191.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.5,29 C331.671573,29 331,28.3284271 331,27.5 C331,26.6715729 331.671573,26 332.5,26 C333.328427,26 334,26.6715729 334,27.5 C334,28.3284271 333.328427,29 332.5,29 Z M332.5,39 C331.671573,39 331,38.3284271 331,37.5 C331,36.6715729 331.671573,36 332.5,36 C333.328427,36 334,36.6715729 334,37.5 C334,38.3284271 333.328427,39 332.5,39 Z M332.5,34 C331.671573,34 331,33.3284271 331,32.5 C331,31.6715729 331.671573,31 332.5,31 C333.328427,31 334,31.6715729 334,32.5 C334,33.3284271 333.328427,34 332.5,34 Z",
    id: "Combined-Shape",
    transform: "translate(332.500000, 32.500000) rotate(90.000000) translate(-332.500000, -32.500000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEllipsis);
export default __webpack_public_path__ + "static/media/Icon_Ellipsis.10dec4ffdcf93a6f556ee6bf8ed09f82.svg";
export { ForwardRef as ReactComponent };